"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = require("classnames");
var React = require("react");
var Icon_1 = require("../Icon");
var CallingTextContainer = function (props) {
    var callingTextRef = props.callingTextRef, children = props.children, handleBlur = props.handleBlur, handleOnClick = props.handleOnClick, handleKeyPress = props.handleKeyPress, _a = props.icon, icon = _a === void 0 ? false : _a, id = props.id, text = props.text, visible = props.visible;
    var containerClassName = (0, classnames_1.default)('tooltip', {
        'tooltip--visible': visible,
        'tooltip--withicon': icon,
    });
    var labelClassName = (0, classnames_1.default)('tooltip__label', {
        'tooltip__label--highlight': visible,
    });
    return (React.createElement("span", { className: containerClassName, tabIndex: 0, id: id + "-tooltip", ref: callingTextRef, "aria-expanded": visible, onClick: handleOnClick, onBlur: handleBlur, onKeyDown: handleKeyPress, role: "button" },
        React.createElement("span", { className: labelClassName }, text),
        icon && (React.createElement(Icon_1.Icon, { className: "tooltip__icon", symbol: "controlInfo24", type: "svginline" })),
        children));
};
exports.default = CallingTextContainer;
